import { useEffect } from 'react'

import type { UtmParams } from 'utils/utmParams'

type Args = {
  id: string | number
  name: string | null
  market: GQL_MarketCode
  country: GQL_Countries
  utmParams?: UtmParams
}

// Properties mirror the iOS event so the platforms group together in Amplitude:
// region_id is stringified to match its GraphQL ID there, and `referrer` is
// omitted because Segment's analytics.js already sends context.page.referrer.
const useAnalyticsPageViewed = ({
  id,
  name,
  market,
  country,
  utmParams = {},
}: Args) => {
  useEffect(() => {
    analytics.track('Region Viewed', {
      region_id: id.toString(),
      region_name: name,
      market,
      country,
      ...utmParams,
    })
  }, [])
}

export default useAnalyticsPageViewed
